import { createTheme, colors } from "@mui/material";
import { useMemo } from "react";
import shadows from "./shadows";
import typography from "./typography";
import BreakPoints from "./breakPoints";

const useAppTheme = (mode) => {
    // console.log("MODE", mode);

    const th = createTheme({
        breakpoints: { values: BreakPoints },
        palette: {
            mode,
            primary: {
                main: `hsl(var(--primary))`,
                dark: `hsl(var(--primary-hover))`,
                contrastText: `hsl(var(--primary-foreground))`,
            },
            secondary: {
                main: `hsl(var(--secondary))`,
                contrastText: `hsl(var(--secondary-foreground))`,
            },
            background: {
                default: `hsl(var(--background))`,
                paper: `hsl(var(--card))`,
            },
            text: {
                primary: `hsl(var(--foreground))`,
                secondary: `hsl(var(--muted-foreground))`,
            },
            popover: {
                main: `hsl(var(--popover))`,
                foreground: `hsl(var(--popover-foreground))`,
            },
        },
        shadows,
        typography,
        components: {
            MuiDialog: {
                styleOverrides: {
                    paper: ({ theme }) => ({
                        background:
                            theme.palette.mode === "dark"
                                ? "hsl(var(--popover))" // Dark mode-д бараан overlay
                                : "hsl(var(--popover))", // Light mode-д цайвар overlay
                        backdropFilter: "blur(10px)", // blur нэмж болно
                        borderRadius: 16,
                        boxShadow:
                            theme.palette.mode === "dark"
                                ? "0 8px 24px rgba(0,0,0,0.5)"
                                : "0 8px 24px rgba(0,0,0,0.2)",
                    }),
                },
            },
        },
    });
    return th;
};

export default useAppTheme;
